'use strict';
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.formatFileSize = void 0;
const react_1 = __importDefault(require('react'));
const rc_utils_1 = require('@hangar31/rc-utils');
const form_1 = require('../../contexts/form');
const _helpers_1 = require('./_helpers');
function formatFileSize(bytes, decimalPoint = 2) {
  // eslint-disable-next-line eqeqeq
  if (bytes == 0) return '0 Bytes';
  const k = 1000;
  const dm = decimalPoint;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
exports.formatFileSize = formatFileSize;
function FileInput(_a) {
  var { className, name, text = 'Upload File' } = _a,
    props = __rest(_a, ['className', 'name', 'text']);
  const { fields, setField } = (0, form_1.useForm)();
  const value = (0, rc_utils_1.getByPath)(fields || {}, name);
  return react_1.default.createElement(
    react_1.default.Fragment,
    null,
    react_1.default.createElement(
      'input',
      Object.assign(
        {
          id: `upload${name}`,
          name: name,
          onChange: e => {
            var _a, _b;
            setField(
              name,
              (_b =
                (_a = e === null || e === void 0 ? void 0 : e.target) ===
                  null || _a === void 0
                  ? void 0
                  : _a.files) === null || _b === void 0
                ? void 0
                : _b[0]
            );
            (0, _helpers_1.checkValidity)(e);
          },
          style: { display: 'none' },
          type: 'file',
        },
        props
      )
    ),
    value &&
      react_1.default.createElement(
        'div',
        { className: className },
        typeof value === 'string' &&
          react_1.default.createElement('strong', null, value),
        typeof value === 'object' &&
          react_1.default.createElement(
            react_1.default.Fragment,
            null,
            react_1.default.createElement('strong', null, value.name),
            ` (${formatFileSize(value.size)})`
          ),
        react_1.default.createElement(
          'button',
          { onClick: () => setField(name, null), type: 'button' },
          'Remove File ',
          react_1.default.createElement('span', null, '\u2297')
        )
      ),
    !value &&
      react_1.default.createElement(
        'div',
        { className: className },
        react_1.default.createElement(
          'label',
          { htmlFor: `upload${name}` },
          react_1.default.createElement('span', null, '\u21A5 '),
          text
        ),
        react_1.default.createElement('small', { className: 'error' })
      )
  );
}
exports.default = FileInput;
//# sourceMappingURL=FileInput.js.map
